import React from 'react';
import './ChecklistInt.css';
import BottomCardGroupInt from "../../BottomCardGroupInt/BottomCardGroupInt";
import {useHistory} from "react-router-dom";

function ChecklistInt(props) {
	const { checklist, bottomCard, campaignOrg,swipeActions,scrollNav } = props;
	const history = useHistory();
	return (
		<>
			<div className="page-content page-content-check" {...swipeActions}>
				<div className="checklist-page-header">
					<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/repl-25-sale-checklist-book-img.png" alt="checkListImg" width={180}/>
				</div>
				<div className="checklist-group">
					{checklist?.map((el, index) => {
						return(
							<div className="checkList-column" key={index}>
								<div className="h2">{el?.title}</div>
								<ul className="check-list-list">
									<li> {el?.body?.[0]}</li>
									<li>{el?.body?.[1]}</li>
								</ul>
							</div>
						)
					})}
				</div>

				{/*<div className="checklist-bottom-card">*/}
				{/*	<h1>3x Growth </h1>*/}
				{/*	<p>3x your earnings by our Specialised features & get chance to win amazing gifts.</p>*/}
				{/*	<BottomCardGroupInt bottomCard={bottomCard} campaignOrg={campaignOrg}></BottomCardGroupInt>*/}
				{/*</div>*/}
			</div>
		</>

	);
}

export default ChecklistInt;
